import { Destination } from 'reducer';

export const destinationHasBudgetDefinitions = (destination: Destination): boolean => {
  return Array.isArray(destination.budgetDefinitions) && destination.budgetDefinitions.length > 0;
};

export const getPossibleTravelTypes = (destination: Destination) => {
  return destination.budgetDefinitions.map((budgetDefinition: any) => budgetDefinition.travelType);
};
